import { createContext, useContext, useState } from "react";
import AuthForm from "@/components/AuthForm";
import { XMarkIcon } from "@heroicons/react/24/outline";

const AuthModalContext = createContext();

export function useAuthModal() {
    return useContext(AuthModalContext);
}

export function AuthModalProvider({ children }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openAuthModal = () => {
        setIsModalOpen(true);
    };

    const closeAuthModal = () => {
        setIsModalOpen(false);
    };

    return (
        <AuthModalContext.Provider value={{ openAuthModal, closeAuthModal }}>
            <div
                className={`${isModalOpen ? "fixed" : "hidden"} z-50 w-full h-screen flex justify-center items-center`}
            >
                <div onClick={closeAuthModal} className="absolute z-50 cursor-pointer bg-black/70 w-full h-full" />
                <div className="bg-white relative z-50 mx-5 w-[30rem] p-10 rounded-lg">
                    <div
                        onClick={closeAuthModal}
                        className="absolute top-0 right-0 text-xs m-6 cursor-pointer hover:text-white hover:bg-secondary text-secondary rounded border border-secondary"
                    >
                        <XMarkIcon className="w-6 h-6" />
                    </div>
                    <AuthForm closeAuthModal={closeAuthModal} />
                </div>
            </div>
            {children}
        </AuthModalContext.Provider>
    );
}
